module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', _vm._g({
    staticClass: "solution-icon",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "type": "button"
    }
  }, _vm.isMobileView ? {
    click: _vm.toggleActive
  } : {
    mouseover: _vm.setActive
  }), [_c('div', {
    staticClass: "icon-wrapper"
  }, [(_vm.item.icon == 'koala') ? _c('svg', {
    attrs: {
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "547.000000pt",
      "height": "547.000000pt",
      "viewBox": "0 0 547.000000 547.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,547.000000) scale(0.100000,-0.100000)",
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2423 4225 c-47 -24 -134 -111 -160 -160 -6 -11 -20 -66 -32 -123\n      -19 -94 -19 -109 -7 -180 22 -128 81 -209 180 -252 l49 -20 -5 -78 c-9 -144\n      -74 -219 -358 -409 -300 -202 -394 -299 -502 -520 -84 -172 -98 -247 -98 -515\n      0 -205 0 -208 30 -289 73 -199 188 -298 432 -369 57 -16 127 -39 156 -50 36\n      -14 76 -20 128 -20 61 0 81 -4 102 -20 16 -13 38 -20 58 -18 20 1 41 -5 53\n      -16 26 -24 51 -14 51 19 l0 26 45 -26 c24 -15 49 -24 55 -20 28 17 -8 117 -48\n      132 -28 11 -82 57 -82 71 0 57 127 -40 178 -136 38 -72 39 -82 7 -130 -31 -48\n      -55 -116 -55 -158 0 -28 4 -34 21 -34 11 0 32 9 46 20 14 11 29 20 32 20 4 0\n      7 -21 7 -47 -1 -45 1 -48 27 -51 23 -3 36 5 67 41 55 62 128 107 173 107 47 0\n      100 -45 123 -105 40 -106 108 -4 70 105 -13 38 -13 47 -2 58 32 33 133 4 185\n      -52 14 -14 35 -26 48 -26 19 0 23 5 23 29 0 17 -4 33 -10 36 -5 3 -10 13 -10\n      21 0 23 46 16 79 -12 17 -14 35 -23 41 -19 16 10 11 78 -8 110 -26 42 -180\n      124 -247 132 -27 3 -62 12 -77 19 -30 15 -69 77 -88 139 -7 22 -36 92 -66 155\n      -40 87 -56 135 -64 194 l-11 79 29 31 c16 17 36 44 44 60 l15 29 33 -59 c19\n      -33 70 -115 114 -184 104 -164 136 -233 147 -322 11 -92 14 -100 44 -128 16\n      -15 30 -20 42 -15 10 4 37 7 60 6 26 -2 56 6 85 20 34 18 69 25 163 31 66 5\n      134 8 150 7 17 0 48 -1 70 -2 36 -2 40 0 43 24 4 34 -56 89 -97 89 -15 0 -43\n      8 -62 17 -24 12 -66 19 -139 21 -58 2 -108 7 -112 11 -14 13 -29 116 -38 271\n      -7 123 -15 176 -39 255 -35 120 -66 356 -52 400 5 17 21 57 36 89 27 57 28 64\n      22 168 -5 77 -14 130 -33 186 -14 42 -23 88 -21 102 3 14 24 77 47 140 23 63\n      47 142 54 174 11 56 14 60 46 69 19 5 49 22 67 38 22 19 45 29 65 29 69 0 149\n      133 149 249 0 31 0 72 1 91 2 43 -6 103 -16 118 -4 6 -2 21 4 32 9 16 8 25 -2\n      37 -7 9 -12 24 -10 34 2 9 -2 20 -8 24 -5 3 -10 19 -10 36 0 17 -5 29 -13 29\n      -7 0 -26 14 -42 30 -26 27 -34 30 -95 30 -36 0 -93 -7 -125 -15 -75 -20 -165\n      -87 -181 -136 -12 -36 -44 -59 -82 -59 -12 0 -55 10 -95 22 -59 18 -98 22\n      -221 22 l-149 1 -28 35 c-19 23 -31 53 -36 85 -13 102 -79 145 -222 145 -73 0\n      -95 -4 -138 -25z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.item.icon == 'tree') ? _c('svg', {
    attrs: {
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1042.000000pt",
      "height": "1042.000000pt",
      "viewBox": "0 0 1042.000000 1042.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,1042.000000) scale(0.100000,-0.100000)",
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3366 9754 c-31 -31 -19 -56 70 -138 117 -110 144 -146 436 -576 139 -206 298 -436 352 -510 270 -369 625 -1147 730 -1603 48 -206 58 -324 76 -868 9 -299 7 -420 -20 -1009 -5 -118 -10 -244 -10 -280 0 -79 -11 -70 -40 33 -29 106 -130 403 -173 509 l-35 87 28 68 c82 204 111 434 74 611 -44 217 -163 384 -370 519 -102 66 -633 336 -804 408 -448 188 -825 283 -942 236 -66 -25 -22 -73 178 -194 364 -222 883 -613 1181 -888 213 -197 424 -471 538 -698 29 -58 160 -441 277 -811 l71 -224 -7 -201 c-4 -110 -9 -201 -11 -203 -1 -2 -42 25 -91 59 -125 87 -319 202 -440 261 -98 48 -194 73 -194 51 0 -6 25 -27 55 -46 136 -91 227 -281 255 -536 31 -284 138 -470 314 -547 l66 -28 0 -56 c0 -82 -20 -565 -26 -637 -5 -60 -7 -62 -39 -73 -53 -17 -153 -86 -223 -154 -85 -81 -186 -206 -322 -401 -149 -212 -203 -278 -275 -336 -161 -132 -343 -186 -705 -209 -282 -18 -446 -58 -632 -151 -165 -82 -368 -241 -402 -314 -16 -34 -16 -38 -1 -61 21 -32 60 -48 188 -79 464 -109 1318 -203 2242 -245 456 -21 1197 -11 1605 20 793 62 1439 226 1514 385 39 81 -10 129 -345 339 -371 233 -449 268 -804 366 -175 48 -296 94 -415 158 -227 121 -458 261 -690 416 -153 103 -294 189 -352 216 l-98 45 0 387 0 387 53 34 c60 39 113 96 133 143 18 43 18 140 0 190 -30 85 35 348 134 545 59 115 99 165 257 315 381 363 544 493 895 712 187 117 314 206 322 228 8 20 -12 22 -134 13 -63 -5 -275 -13 -470 -19 -236 -6 -384 -15 -440 -25 -293 -53 -486 -136 -655 -282 l-85 -73 0 130 0 130 46 93 c206 411 482 875 667 1122 147 196 565 569 932 832 420 302 979 600 1345 718 137 45 290 131 290 164 0 29 -41 34 -170 22 -63 -6 -187 -15 -275 -21 -225 -15 -612 -67 -806 -110 -457 -99 -922 -402 -1254 -815 -164 -204 -309 -447 -349 -584 -35 -121 -12 -229 54 -254 17 -6 30 -15 30 -19 0 -4 -46 -78 -103 -165 -57 -87 -166 -257 -242 -378 -75 -121 -143 -226 -150 -234 -10 -11 -14 62 -17 375 -5 407 -17 568 -72 954 l-23 165 27 35 c249 325 259 813 26 1280 -286 573 -741 966 -1411 1218 -88 34 -177 68 -197 76 -49 21 -122 21 -142 0z m1951 -5615 l32 -24 -39 -105 c-22 -58 -47 -132 -56 -165 l-17 -60 -38 44 -39 44 0 208 0 208 63 -63 c34 -34 77 -74 94 -87z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.item.icon == 'renewable') ? _c('svg', {
    attrs: {
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1042.000000pt",
      "height": "1042.000000pt",
      "viewBox": "0 0 1042.000000 1042.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,1042.000000) scale(0.100000,-0.100000)",
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9468 8802 c-53 -48 -108 -100 -121 -117 -31 -40 -617 -912 -617 -919 0 -3 20 -6 45 -6 92 0 202 -56 251 -128 l21 -31 126 237 c234 440 363 723 393 862 15 71 18 158 6 177 -5 7 -40 -18 -104 -75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3302 7586 l-441 -271 -3 -197 -3 -196 -155 93 c-85 52 -161 94 -167 95 -7 0 -273 -164 -590 -363 l-578 -364 -6 -294 c-3 -162 -7 -1111 -9 -2109 -1 -998 -5 -1862 -9 -1919 l-6 -105 -435 -205 -434 -206 427 -3 427 -2 1943 886 c1068 487 1947 888 1954 891 6 3 871 -396 1922 -886 l1910 -891 452 2 452 3 -529 256 -529 255 -3 2183 -2 2183 -168 279 -167 279 -5 -1392 -5 -1393 -175 -3 -176 -2 -129 -130 -130 -130 233 0 232 0 0 -37 0 -37 68 67 c37 37 71 67 75 67 4 0 7 -396 7 -880 0 -484 -3 -880 -7 -880 -4 0 -227 106 -495 236 l-488 237 0 333 0 334 -105 0 -105 0 0 -281 c0 -255 -1 -281 -16 -275 -9 4 -275 131 -590 284 l-574 277 0 242 0 243 -110 0 -110 0 0 -189 0 -190 -272 133 c-150 73 -305 147 -344 165 l-71 33 -288 -136 c-158 -75 -291 -136 -296 -136 -5 0 -9 508 -9 1165 0 641 2 1165 4 1165 2 0 184 -101 405 -225 221 -124 404 -225 407 -225 2 0 3 44 2 97 l-3 97 -405 233 c-223 127 -411 232 -417 232 -7 1 -266 -152 -575 -338 l-563 -339 -3 -1207 -2 -1206 -103 -49 -102 -49 -3 1327 c-1 730 0 1332 2 1337 2 6 99 68 215 139 l211 129 0 924 c0 507 4 923 8 923 5 0 145 -74 311 -165 166 -91 309 -169 318 -172 14 -6 15 2 9 67 -3 41 -8 75 -9 76 -1 1 -144 87 -318 192 l-316 189 -441 -271z m-437 -849 l310 -194 0 -1859 0 -1859 -310 -147 c-170 -81 -313 -147 -317 -147 -5 -1 -8 989 -8 2199 0 1210 4 2200 8 2200 4 0 147 -87 317 -193z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8040 7583 c-243 -13 -569 -36 -635 -44 -106 -13 -252 -52 -314 -83 -56 -29 -66 -40 -48 -54 28 -22 211 -83 294 -96 140 -24 472 -47 871 -62 l182 -7 -7 34 c-10 44 -10 200 0 267 l8 52 -148 -2 c-81 -1 -173 -3 -203 -5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8645 7576 c-42 -18 -82 -68 -95 -117 -19 -70 6 -140 67 -186 31 -24 46 -28 103 -28 58 0 71 4 104 29 42 32 76 95 76 141 0 38 -31 104 -61 132 -48 43 -132 56 -194 29z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9036 7192 c-18 -54 -132 -116 -246 -131 -39 -5 -54 -11 -52 -21 7 -31 572 -860 627 -919 33 -35 94 -91 135 -124 l75 -60 3 91 c3 84 0 96 -34 184 -36 89 -461 946 -488 984 -13 17 -14 17 -20 -4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8218 6960 c-52 -47 -105 -118 -257 -344 -105 -157 -191 -287 -191 -290 0 -3 10 -6 21 -6 43 0 103 -25 137 -57 32 -30 36 -32 47 -16 26 35 234 450 270 537 26 64 38 110 42 163 3 40 4 73 2 73 -2 0 -34 -27 -71 -60z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7175 6199 c-253 -16 -395 -42 -450 -83 -19 -14 -18 -16 26 -35 105 -47 248 -65 609 -79 l185 -7 0 108 0 107 -120 -1 c-66 -1 -178 -6 -250 -10z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7704 6199 c-28 -14 -54 -60 -54 -96 0 -113 157 -148 205 -46 45 95 -55 188 -151 142z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7935 5940 c-27 -28 -88 -53 -151 -62 -19 -3 3 -39 175 -292 162 -240 207 -299 261 -345 l65 -55 3 60 c2 53 -2 73 -36 150 -41 92 -208 429 -259 521 l-29 53 -29 -30z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7650 5010 l0 -820 -28 0 c-22 0 -50 -24 -150 -130 l-123 -130 228 0 228 0 130 130 130 130 -98 0 -97 0 0 642 0 642 -106 178 c-59 98 -108 178 -110 178 -2 0 -4 -369 -4 -820z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5501 4550 l-133 -130 228 0 229 0 130 130 130 130 -225 0 -225 -1 -134 -129z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6080 4550 l-122 -130 229 0 228 0 130 130 130 130 -237 0 -236 0 -122 -130z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6670 4549 l-124 -129 232 0 232 0 0 -37 0 -38 130 130 c121 120 130 132 130 167 l0 38 -237 -1 -238 -2 -125 -128z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5117 4182 c-147 -147 -157 -160 -157 -195 l0 -37 230 0 230 0 0 38 c0 32 7 45 51 87 28 28 96 98 151 158 l100 107 -224 0 -223 0 -158 -158z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5723 4178 c-145 -144 -163 -165 -163 -195 l0 -33 220 0 220 0 0 37 c0 35 10 48 157 195 l158 158 -215 0 -215 0 -162 -162z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6303 4174 c-118 -125 -159 -173 -161 -195 l-3 -29 240 0 240 0 145 158 c133 144 146 160 146 195 l0 37 -224 0 -224 0 -159 -166z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6898 4063 l-133 -128 225 -3 225 -2 130 130 130 130 -222 0 -221 0 -134 -127z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6512 3692 c-145 -140 -163 -160 -162 -189 l0 -33 235 0 235 0 0 35 c0 30 14 49 118 157 64 68 130 138 146 156 l30 32 -220 0 -219 -1 -163 -157z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7117 3692 c-138 -138 -157 -161 -157 -190 l0 -32 220 0 220 0 0 35 c0 31 15 50 151 190 l151 155 -213 0 -214 0 -158 -158z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7697 3686 c-120 -125 -157 -170 -157 -190 l0 -26 243 0 242 1 135 149 c120 134 135 154 138 190 l3 40 -224 0 -224 0 -156 -164z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4770 2245 l0 -195 195 0 195 0 0 195 0 195 -195 0 -195 0 0 -195z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5300 2245 l0 -195 195 0 195 0 0 195 0 195 -195 0 -195 0 0 -195z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4770 1735 l0 -195 195 0 195 0 0 195 0 195 -195 0 -195 0 0 -195z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5300 1735 l0 -195 195 0 195 0 0 195 0 195 -195 0 -195 0 0 -195z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.item.icon == 'innovate') ? _c('svg', {
    attrs: {
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1042.000000pt",
      "height": "1042.000000pt",
      "viewBox": "0 0 1042.000000 1042.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,1042.000000) scale(0.100000,-0.100000)",
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5034 8799 c-482 -37 -937 -217 -1289 -510 -390 -325 -674 -753 -790 -1192 -48 -182 -67 -320 -72 -542 -8 -338 31 -588 134 -855 97 -252 225 -461 466 -760 48 -59 90 -128 137 -225 135 -276 190 -502 240 -995 41 -398 52 -451 114 -516 65 -67 102 -74 434 -81 l282 -6 0 900 0 900 -29 44 c-17 24 -48 62 -70 84 -41 39 -41 39 -70 22 -42 -25 -137 -47 -202 -47 -70 0 -191 30 -261 66 -98 49 -165 112 -252 234 -215 301 -297 423 -290 430 12 12 174 57 269 75 44 9 132 18 195 21 195 9 329 -26 441 -116 146 -117 219 -266 219 -445 l0 -80 93 -90 c72 -69 96 -100 105 -131 9 -30 12 -282 12 -953 l0 -911 60 0 60 0 0 1328 0 1328 -29 45 c-16 24 -58 73 -94 107 l-64 64 -69 -25 c-194 -70 -370 -52 -531 52 -113 73 -206 184 -298 356 -56 105 -193 311 -300 450 -41 54 -72 101 -70 106 3 4 40 16 83 26 107 25 403 25 554 0 298 -50 435 -104 553 -220 57 -57 81 -90 113 -157 58 -123 66 -165 67 -335 l0 -151 90 -80 c111 -100 120 -111 140 -157 13 -32 15 -194 15 -1387 l0 -1350 55 0 55 0 2 1523 3 1522 27 46 c15 25 44 61 65 79 21 18 57 51 81 72 l43 40 -15 62 c-20 78 -20 233 -1 305 59 222 279 404 576 476 173 42 357 58 579 52 107 -3 203 -8 213 -12 15 -7 10 -22 -49 -133 -142 -270 -295 -486 -459 -647 -104 -103 -171 -150 -273 -191 -116 -47 -281 -55 -409 -20 l-52 14 -67 -70 c-115 -123 -104 64 -104 -1635 l0 -1483 60 0 60 0 0 1103 c0 1045 1 1104 19 1142 10 23 54 74 103 120 l86 80 -5 70 c-18 259 134 450 432 541 82 26 104 28 245 28 172 0 276 -16 417 -63 46 -16 87 -31 90 -34 9 -10 -80 -156 -162 -265 -257 -344 -599 -560 -810 -513 -31 7 -77 27 -104 46 l-49 33 -35 -37 c-72 -75 -67 18 -67 -1177 l0 -1077 303 6 c180 3 321 10 349 17 26 7 65 27 86 46 76 65 100 154 132 484 49 516 113 779 256 1060 63 124 118 208 229 350 263 336 408 650 476 1035 19 109 23 165 23 350 0 220 -5 280 -45 485 -50 255 -189 588 -338 810 -322 479 -811 829 -1355 970 -260 68 -501 89 -762 69z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4103 3007 c-108 -22 -172 -149 -127 -255 22 -53 60 -89 113 -106 150 -48 1521 -59 2113 -17 131 9 187 33 223 95 52 88 23 213 -60 262 l-43 25 -1091 2 c-600 1 -1107 -1 -1128 -6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4225 2481 c-149 -69 -149 -275 0 -342 38 -18 90 -19 981 -19 l940 0 50 25 c60 30 93 76 101 142 10 88 -28 161 -101 194 -39 18 -87 19 -986 19 -899 0 -947 -1 -985 -19z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4520 2011 c-91 -14 -112 -50 -70 -118 72 -119 223 -208 420 -248 179 -37 574 -29 748 16 186 47 372 205 360 307 -6 52 2 52 -733 51 -374 -1 -700 -5 -725 -8z"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "wwf-font"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "arrow-open"
  }, [_c('i', {
    staticClass: "fas fa-chevron-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "arrow-more"
  }, [_c('i', {
    staticClass: "fas fa-chevron-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-210be5ed","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!./~/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./src/components/hub/SolutionsButton.vue
// module id = 622
// module chunks = 0